import type { track as TrackFn } from "pro-features/components/WithTrack/src/WithTrack";

export default function createAssignToUsersTrackingService(track: TrackFn) {
    return {
        trackSelectButtonClicked() {
            track("multi select actions", "select user", "assign to others");
        },
        trackUserSelected(numberOfWebsitesToAssign: number, assigneeName?: string) {
            const name = assigneeName ? `/${numberOfWebsitesToAssign}/${assigneeName}` : "";
            track("multi select actions", "assign websites", `assign to others${name}`);
        },
    };
}
